// Module
var code = "<div ng-controller=\"CreateTaxPaymentController\" class=\"view-contents\"> <div ng-include=\"'/app/payables/ach/payments/views/createTaxPaymentSingle.html'\" style=\"height:100%\" ng-init=\"isNewPayment = true\"></div> </div> ";
// Exports
module.exports = code;